import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';
import { SharedModule } from '../../shared/shared.module';

@Component({
  selector: 'app-pdf-preview-page',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './pdf-preview-page.component.html',
  styleUrl: './pdf-preview-page.component.scss'
})
export class PdfPreviewPageComponent implements OnInit {

  safeUrl: SafeResourceUrl | null = null;
  fileUrl  = '';
  fileName = '';
  title    = '';
  subtitle = '';
  avatarUrl  = '';
  showAvatar: boolean | undefined = undefined;

  constructor(
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.fileUrl   = params['url']       || '';
      this.fileName  = params['fileName']  || '';
      this.title     = params['title']     || '';
      this.subtitle  = params['subtitle']  || '';
      this.avatarUrl  = params['avatarUrl']  || '';
      this.showAvatar = params['showAvatar'] === 'false' ? false : undefined;
      if (this.fileUrl) {
        this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.fileUrl);
      }
    });
  }

  getInitials(name: string): string {
    if (!name) return '?';
    return name.split(' ').map(n => n[0]).join('').toUpperCase().substring(0, 2);
  }

  getAvatarUrl(image: string): string {
    if (!image) return '';
    return image.startsWith('http') ? image : `${environment.fileBaseUrl}${image}`;
  }
}